import { render, staticRenderFns } from "./prescription-draft.vue?vue&type=template&id=7fe57988&scoped=true&lang=pug&"
import script from "./prescription-draft.vue?vue&type=script&lang=ts&"
export * from "./prescription-draft.vue?vue&type=script&lang=ts&"
import style0 from "./prescription-draft.vue?vue&type=style&index=0&id=7fe57988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe57988",
  null
  
)

export default component.exports